import React from 'react';
import { connect } from "react-redux";
import Loader from '../../../../Global/loader.js'
import { store } from 'react-notifications-component';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from "react-js-pagination";
import { AiFillEdit } from 'react-icons/ai'
import { RiDeleteBin5Line } from 'react-icons/ri'
import Modal from 'react-modal';
import deleteTaxRate from '../../../../API/Provider/DeleteProviderTaxRate'
import { Button, Row, Col, Form } from "react-bootstrap";
import Create from './CreatePorezi.js'
import Update from './UpdatePorezi.js'
import { BsBackspaceFill } from 'react-icons/bs'
import { withNamespaces } from 'react-i18next';
import Select from 'react-select'
import GetCountries from '../../../../API/Provider/GetProviderCountries'
import getProviderTaxRatesList from '../../../../API/Provider/GetProviderTaxRatesList';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import ButtonWithDropdown from '../../../../Global/ButtonWithDropdown'
import updateUser from '../../../../API/Provider/PutUser'
import history from '../../../../history.js';
import CreateButton from './../../../../Global/CreateButton'

class Porezi extends React.Component {
    constructor(props) {
        super(props)
    
        this.state={
            loading: true,
            create: false,
            showDeleteModal: false,     
            uuidForDelete: "",  
            showOneItem: false,
            
            customStyles: {
                content : {
                    top                   : '50%',
                    left                  : '50%',
                    right                 : 'auto',
                    bottom                : 'auto',
                    transform             : 'translate(-50%, -50%)',
                    color: 'red'
                }
            }  
            
        }
    }

    componentDidMount = async () => {        
        document.title = this.props.t("Tax rates") + "-" + this.props.t("List")
        
        this.setState({loading: true})   
        
        let data = {
            activePage: 1,
            pageSize: 1000,
            search:{
                searchFor: ""
            },
            sortBy: {id: 0},
            sortDirection: 0,
            activeOnly: "Active"
        }
      
        //get countries
        let items = await GetCountries(data)       
        let countryList = []

        await items.data.countries
            .map((data, index) =>{
            let oneItem = {value: data.uuid , label: data.country_name }
            countryList.push(oneItem)
            return null
        })

        if(this.props.taxRatesPickedCountry.value === "0"){
            await this.props.mapState("MAP_PROVIDERS_TAX_RATES_PICKED_COUNTRY", countryList[0])
        }
        await this.setState({
            countries: countryList,
            country: countryList[0]
        })

        await this.search()

        await this.setState({
            loading: false            
        })
    }

    toggleCreate = async () => {
        await this.setState({
            create: !this.state.create
        })
    }

    backFromCreate= async() => {
        await this.setState({
            create: !this.state.create
        })
        await this.componentDidMount()
    }

    showDeleteModal = (uuid, countryUuid) => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            uuidForDelete: uuid,
            countryUuid: countryUuid
        });
    };

    confirmDelete = async () => {
        
        let deleteItem = await deleteTaxRate(this.props.oneClientInfo.uuid, this.state.uuidForDelete, this.props.taxRatesPickedCountry.value)   
        if(deleteItem.data.status !== 200){
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: "",
                countryUuid: ""
            })     
            await store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t("There was an error deleting the tax, please try again"),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 15000,
                  onScreen: true
                }
            }) 

            this.search()
        }
        else{
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: "",
                countryUuid: ""
            }) 

            await store.addNotification({
                title: this.props.t('Success!'),
                message: this.props.t("Tax has been deleted"),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            }) 

            this.search()
        }
        
    }

    seeDetails = async (data) => {
        
        await this.props.mapState("MAP_PROVIDER_ONE_TAX_RATE", data)
        await this.setState({
            showOneItem: !this.state.showOneItem
        })
    }

    handleCountryChange = async (e) =>{  

        await this.props.mapState("MAP_PROVIDERS_TAX_RATES_PICKED_COUNTRY", e)
        this.setState({
            country: e
        })    
        
        this.search()
    }

    backFromEdit = async () =>{
        this.setState({
            showOneItem: !this.state.showOneItem
        })
        this.search()
    }

    goBack(){
        history.goBack();
    }

    search = async() => {

        await this.setState({ loading: true})

        let lista = await getProviderTaxRatesList(this.props)

        if(lista.data.status === 200){
            this.props.mapState("MAP_PROVIDERS_TAX_RATES_LIST", lista.data.data)
        }
        else{
            this.props.mapState("MAP_TAX_RATES_LIST", [])
        }
        
        await this.setState({ loading: false})
    }

    handlePageChange(pageNumber) {

        this.props.mapState("MAP_PROVIDER_TAX_RATE_LIST_ACTIVE_PAGE", pageNumber);

        this.search();
    }

    handleItemsPerPageChange(itemsPerPage) {
        this.setState({ itemsPerPage: itemsPerPage });

        this.search();
    }

    onItemsPerPageChange = async (size) => {
        this.props.mapState("MAP_PROVIDER_TAX_RATE_LIST_PAGE_SIZE", size);
        this.props.mapState("MAP_PROVIDER_TAX_RATE_LIST_ACTIVE_PAGE", 1);
        this.search();
    };

    toggleOnlyActive = async (data) => {
        this.setState({
            loading: true
        })

        await this.props.mapState("MAP_PROVIDER_TAX_RATE_ACTIVE_ONLY", data)
        await this.search();       
    }

   
    render(){  
        const { loading, create, showOneItem} = this.state 
        const { t } = this.props

        const columns = [{
            dataField: 'country',
            text: t('Country'),
            headerStyle: {wordWrap: "break-word"}, 
            hidden: this.props.user.user_web_properties.columns.provider.tax_rate.country
        }, {
            dataField: 'tax_rate_mark',
            text: t('Form.Label'),
            headerStyle: {wordWrap: "break-word"},   
            hidden: this.props.user.user_web_properties.columns.provider.tax_rate.tax_rate_mark
        },{
            dataField: 'tax_rate',
            text: t('Tax Rate'),
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.tax_rate.tax_rate,
            formatter: (cellContent, row) => {          
                return (
                    <div key={row.uuid}>
                        <span>{row.tax_rate}%</span>
                    </div>
                )}
        }, {
            dataField: 'tax_rate_description',
            text: t('Description'),
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.tax_rate.tax_rate_description,
        }, {
            dataField: 'note',
            text: t('Note'),
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.provider.tax_rate.note,
        },{
            dataField: 'sakriveno',
            isDummyField: true,
            text: '',
            style:{  width: '11.8em' },
            formatter: (cellContent, row) => {          
            return (
                row.deleted === "" &&
                <div key={row.uuid}>
                    <Button 
                        variant='success'
                        className="btnDetalji me-2" 
                        onClick={() =>this.seeDetails(row)}
                    > 
                        <AiFillEdit /> {t('Details')} 
                    </Button> 

                    <Button
                        variant='danger'
                        className="btnIzbrisi"
                        onClick={() => this.showDeleteModal(row.uuid, row.country_uuid)}
                    >
                        <RiDeleteBin5Line /> {t('Delete')}
                    </Button>
                </div>
            );
            }
        }]  

        /* CUstom filter buttons */
        const CustomToggleList = ({ columns, onColumnToggle, toggles}, customFunkcija) => {

            //asiknrona funkcija za poziv default toggler funkcije + sprmenje promjene za poziv prema serveru
            customFunkcija = async (column) => {
                
                await onColumnToggle(column.dataField)
                let data = { menu: "provider", view: "tax_rate" , column: column.dataField }
                await this.props.mapState("USER_MAP_COLUMNS", data)
                await updateUser(
                    this.props.user,
                    this.props.user.provider_uuid
                )
            }
            
            return <div className="btn-group btn-group-toggle" data-toggle="buttons">
              {columns
                .filter(data => data.dataField !== "sakriveno")
                .map(column => ({
                  ...column,
                  toggle: toggles[column.dataField]
                }))
                .map((column) => (
                    <button                         
                        key = {column.dataField}
                        type="button" 
                        className={ ` ${column.toggle ? ' btn btn-success active' : 'btn btn-danger'}` }
                        data-toggle="button" 
                        label={column.text}
                        id={column.dataField}
                        aria-pressed={(column.toggle) ? "true" : "false"}
                        onClick={() => customFunkcija(column) }
                    >
                        {column.text}
                    </button>
                ))}
            </div>
        };

    return (
        <>
        {loading ? 
            <Loader />
        :
            <>
                {create ? 
                    <Create goBack={() => this.backFromCreate()} />
                :
                showOneItem ? 
                    <Update goBack={() => this.backFromEdit()} />
                :
                    <>
                        <Row>
                            <Col sm={12} lg={12} xl={12}>
                               <Form.Group as={Row} className="mb-3">
                                    <Col sm={12} xl={2} className="p-4">
                                        {this.props.taxRatesPickedCountry.value !== "0" ?       
                                            <Select
                                                options={this.state.countries} 
                                                onChange={(values) => this.handleCountryChange(values)}
                                                isInvalid={this.props.taxRatesPickedCountry === null}
                                                value={this.props.taxRatesPickedCountry}  
                                                className={"dropdown-country"}
                                                classNamePrefix={"dropdown-country"}
                                                maxMenuHeight={200}         
                                            />
                                        : null}
                                    </Col>
                                    
                                    <Col sm={6} xl={10}>
                                        <CreateButton className="col-6 col-xl-4 p-4" toggleCreate={this.toggleCreate}/>
                                    </Col>
                                </Form.Group>                      
                            </Col>
                        </Row>
                        
                        {this.props.taxRatesList.tax_rates?.filter(data => data.deleted === "").length > 0 ?
                        <>
                            <ToolkitProvider
                                keyField="uuid"
                                data={this.props.taxRatesList.tax_rates?.filter(data => data.deleted === "")}
                                columns={columns}
                                columnToggle     
                                prikaziSakrij = {this.prikaziSakrij}    
                                bodyStyle={ {wordBreak: 'break-word'} }                         
                            >
                                {(props) => (
                                <div>
                                    <CustomToggleList {...props.columnToggleProps} />
                                    <hr />
                                    <BootstrapTable {...props.baseProps} hover bodyClasses="table-body" />
                                </div>
                                )}
                            </ToolkitProvider>   

                            <div className="container">
                                <Row className="justify-content-md-center m-0 pt-2" >
                                    <Col sm={2}>
                                        <ButtonWithDropdown 
                                            itemsPerPage={[10, 20, 30, 50]}
                                            active={this.props.pageSize}
                                            onItemsPerPageChange={this.onItemsPerPageChange}
                                            className="itemsPerPage"
                                            toggleId="dropdown-basic"
                                            styleToggle={{width:"auto"}}
                                        />
                                    </Col>
                                
                                    <Col sm={8} className="text-center">
                                        <Pagination
                                            className="pagination"
                                            firstPageText="1"
                                            lastPageText={Math.ceil(
                                                this.props.taxRatesList.total_number_of_records /
                                                    this.props.pageSize
                                            ).toString()}
                                            hideDisabled
                                            activePage={this.props.activePage}
                                            itemsCountPerPage={this.props.pageSize}
                                            totalItemsCount={this.props.taxRatesList.total_number_of_records}
                                            pageRangeDisplayed={5}
                                            onChange={this.handlePageChange.bind(this)}
                                            itemClass="page-item"
                                            linkClass="page-link"
                                        />
                                    </Col>

                                    <Col sm={2}>
                                        <ButtonWithDropdown 
                                            itemsPerPage={["All", "Active", "Inactive"]}
                                            active={this.props.activeOnly}
                                            onItemsPerPageChange={this.toggleOnlyActive}
                                            toggleId="dropdown-basic"
                                            className="itemsPerPage" 
                                            styleToggle={{
                                                float:"right",
                                                width: "auto",
                                                fontSize: "large"
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </div>  
                        </>
                        : 
                            <div className="list-empty-container">
                                <h1>{t(this.props.message)}</h1>
                            </div> 
                        }

                        <Modal
                            isOpen={this.state.showDeleteModal}                
                            onRequestClose={() => this.showDeleteModal("")}
                            style={this.state.customStyles}
                        >

                            <h3 className="modal-title">{t('Warning!')}</h3>
                    
                            <div className="mb-4">
                                <p>
                                    {t('Deleting the Tax Rate will also delete other data related to it.')}       
                                </p>                     
                            </div>


                            <Row>
                                <div className="col col-6">
                                    <Button variant="primary" onClick={() => this.showDeleteModal("")}>{t('Close')}</Button>
                                </div>
                                <div className="col col-6">
                                    <Button variant="danger" onClick={() => this.confirmDelete()}> {t('DELETE')}</Button>
                                </div>                
                            </Row>
                    
                        </Modal> 


                        <div className="form-group mt-5">
                            <div
                                className="btn btn-default"
                                onClick={() => history.goBack()}                       
                            > 
                                <BsBackspaceFill size={30} />  
                                <strong> {t('Back')} </strong>
                            </div> 
                        </div> 
                    </>
                }
                         
            </>
        }
        </>
    )
}
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        taxRatesList: state.provider.taxRatesList,
        message: state.adminClient.message,
        user: state.user,
        taxRatesPickedCountry: state.provider.taxRatesPickedCountry,
        activeOnly: state.provider.activeOnlyTaxRate,
        pageSize: state.provider.pageSizeTaxRate,
        activePage: state.provider.activePageTaxRate,        
        providerTaxRateVisibleColumns: state.provider.providerTaxRateVisibleColumns
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(Porezi));